export const IS_SERVER = typeof window === 'undefined';
export const IS_PROD = process.env.NODE_ENV === 'production';
export const IS_DEV = process.env.NODE_ENV === 'development';
export const API_URL = process.env.REACT_APP_API_URL;
export const PAGE_SIZE = 20;
export const MOBILE_PAGE_SIZE = 12;
export const LARGE_PAGE_SIZE = 100;
export const WEEKS_MAP = [
  { day: 0, resourceId: 1, resourceTitle: '일요일' },
  { day: 1, resourceId: 2, resourceTitle: '월요일' },
  { day: 2, resourceId: 3, resourceTitle: '화요일' },
  { day: 3, resourceId: 4, resourceTitle: '수요일' },
  { day: 4, resourceId: 5, resourceTitle: '목요일' },
  { day: 5, resourceId: 6, resourceTitle: '금요일' },
  { day: 6, resourceId: 7, resourceTitle: '토요일' },
];
export const CHART_RGB = [
  '#f47560',
  '#61cdbb',
  '#e8c1a0',
  '#e8a838',
  '#9e0142',
  '#3288bd',
  '#5e4fa2',
  '#FF3333',
  '#FF9900',
  '#F2DB00',
  '#00CC66',
  '#B077CC',
  '#0099FF',
  '#6E4A7F',
  '#FFCC66',
  '#66CCFF',
  '#8CC75E',
  '#BF9663',
  '#5CF2F2',
  '#F26B6B',
  '#1C2126',
];
export const LINE_RGB = [
  'maroon',
  'fuchsia',
  'blue',
  'teal',
  '#9acd32',
  '#d8bfd8',
  '#2e8b57',
  '#D93D59',
  '#0597F2',
  '#76232D',
  '#585932',
];
export const LEVELS = [
  ['normal', '레드'],
  ['orange', '오렌지'],
  ['yellow', '옐로우'],
  ['block', '그린'],
  ['vip', '블루'],
  ['purple', '퍼플'],
  ['none', '일반'],
];
export const COLORS = [
  ['#757575', '블랙'],
  ['#E57373', '레드'],
  ['#FFB74D', '오렌지'],
  ['#F7CB00', '옐로우'],
  ['#81C784', '그린'],
  ['#7986CB', '블루'],
  ['#CE93D8', '퍼플'],
];
